import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import { getFadeTransitionDiv } from './FadeTransition.style';
import { FADE_TRANSITION_TIME } from './utils/constants';

const FadeTransitionDiv = getFadeTransitionDiv(FADE_TRANSITION_TIME);

const transitionStyles = {
    entering: { opacity: 1 },
    entered: { opacity: 1, visibility: 'visible' },
    exiting: { opacity: 0 },
    exited: { opacity: 0, visibility: 'hidden' },
};

const FadeTransition = ({ in: inProp, children, className }) => (
    <Transition in={inProp} timeout={FADE_TRANSITION_TIME}>
        {(state) => (
            <FadeTransitionDiv
                style={{
                    ...transitionStyles[state],
                }}
                className={className}
            >
                {children}
            </FadeTransitionDiv>
        )}
    </Transition>
);

FadeTransition.defaultProps = {
    in: false,
    children: null,
    className: '',
};

FadeTransition.propTypes = {
    in: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
};

export { FadeTransition };
